import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ICreateReceivedPaymentRequestParams } from "../../../domain/ICreateReceivedPaymentRequestParams";
import { FormatDateIso, getYestardaysDate } from "utils/dateUtils";
import { toast } from "react-toastify";
import { useAppDispatch } from "hooks/hooks";
import {
  createReceivedPayment,
  selectAccountReceivableForPaymentCreation,
  setIndexForPaymentCreation,
  setPaymentCreationPopover,
} from "../accountReceivable.slice";
import { useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";
import classes from "../../../../../../components/Popover/popover.module.scss";
import classesP from "../../../styles/popovers.module.scss";
import { IMaskInput } from "react-imask";
import { useEffect } from "react";

export const NewReceivedPaymentPopover = () => {
  const dispatch = useAppDispatch();
  const account = useSelector(selectAccountReceivableForPaymentCreation);

  const {
    handleSubmit,
    control,
    register,
    formState: { errors },
    reset,
    setFocus
  } = useForm<ICreateReceivedPaymentRequestParams>({
    defaultValues: { date: getYestardaysDate() }
  });

  const closeDialog = () => {
    dispatch(setIndexForPaymentCreation(-1));
    dispatch(setPaymentCreationPopover({ isOpen: false }));
    reset();
  };

  useEffect(() => {
    setFocus("amount");
  }, [setFocus]);

  const onSubmit = async (data: ICreateReceivedPaymentRequestParams) => {
    try {
      await dispatch(createReceivedPayment(data)).unwrap();
      closeDialog();
      toast.success("Red je uspesno dodat.");
    } catch (status: any) {
      if (status === 406) {
        toast.error("Unos nije moguć jer postoji neki problem sa ovim saradnikom");
      } else if (status === 404) {
        toast.error("Unos nije moguć jer neki od unetih podataka nije regularan");
      } else if (status === 400) {
        toast.error("Unos nije moguć zbog neočekivane greške");
      }
    }
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className={`${classesP.newAccountReceivablePopover}
        ${classes.basicPopover}`}>
      <input
        type="hidden"
        value={account?.receivableId}
        {...register("accountReceivableId")}
      />

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>br. fakture:</label>
          <input type="text" value={account != null ? account.invoiceId : ""}
            className={`${classes.itemBorder} ${classes.transparent} ${classes.lightDark}`}
            disabled
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>iznos:</label>
          <Controller
            control={control}
            name="amount"
            defaultValue={undefined}
            rules={{
              required: true,
            }}
            render={({ field: { onChange, value } }) => (
              <IMaskInput
                autoFocus
                onAccept={(value, mask) => onChange({ target: { value: mask.unmaskedValue } })}
                mask={Number}
                className={`${classes.itemBorder} ${errors.amount ? classes.itemError : ""}`}
              />
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>datum plaćanja:</label>
          <Controller
            control={control}
            name="date"
            defaultValue={undefined}
            rules={{
              required: true,
            }}
            render={({ field: { onChange, value } }) => (
              <div>
                <DatePicker
                  onChange={(date) =>
                    onChange(date ? FormatDateIso(date) : undefined)
                  }
                  dateFormat="dd.MM.yyyy"
                  showMonthDropdown
                  showYearDropdown
                  selected={value ? new Date(value) : null}
                  className={`${classes.itemBorder} ${classes.dateItem}
                  ${errors.date ? classes.itemError : ""}`}
                />
              </div>
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>keš</label>
          <div>
            <input type="checkbox" {...register("isCash", { required: false })}
              className={`${errors?.isCash ? classes.itemError : ""}`} />
          </div>
        </div>
      </div>

      <div className={classes.row}>
        <div className={classes.buttons}>
          <button className={classes.iconButton} type="submit">
            <FontAwesomeIcon icon={faLongArrowAltDown} className={classes.icon} />
          </button>
        </div>
      </div>
    </form>
  );
};
